export const avatarHandler = (value?: File | string | undefined) => {
  if (typeof value === 'object') {
    return URL.createObjectURL(value);
  }
  if (typeof value === 'string') {
    return value;
  } return null;
};
